import BinanceLogo from "../../assets/cexes/binance.webp";
import BybitLogo from "../../assets/cexes/bybit.webp";
import MexcLogo from "../../assets/cexes/mexc.webp";
import GateLogo from "../../assets/cexes/gate.webp";
import OkxLogo from "../../assets/cexes/okx.webp";
import KucoinLogo from "../../assets/cexes/kucoin.webp";
import CoinbaseLogo from "../../assets/cexes/coinbase.webp";
import KrakenLogo from "../../assets/cexes/kraken.webp";
import BitgetLogo from "../../assets/cexes/bitget.webp";

// Mapping CEX names to their logos
const cexLogoMap: Record<string, string> = {
  Binance: BinanceLogo,
  Bybit: BybitLogo,
  MEXC: MexcLogo,
  "Gate.io": GateLogo,
  OKX: OkxLogo,
  Kucoin: KucoinLogo,
  Coinbase: CoinbaseLogo,
  Kraken: KrakenLogo,
  Bitget: BitgetLogo,
};

export const CEXLogos = ({ cexes }: { cexes: string[] }) => {
  const logos = cexes
    .filter((cex) => cexLogoMap[cex])
    .map((cex) => cexLogoMap[cex]);

  const additionalCexes = cexes.length - logos.length;

  if (cexes.length === 0) {
    return <div className="text-sm font-medium">Unavailable</div>;
  }

  return (
    <div className="flex items-center gap-1">
      {logos.map((logo, index) => (
        <img
          key={index}
          className="h-5 w-5 rounded-full"
          src={logo}
          alt="CEX logo"
        />
      ))}
      {additionalCexes > 0 && (
        <span className="text-sm font-medium">
          {logos.length > 0 ? "+" : ""}
          {additionalCexes}
        </span>
      )}
    </div>
  );
};
